import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { createDecorator } from '../../instantiation/common/instantiation.js';
import { Emitter } from '../../../base/common/event.js';
import { Disposable } from '../../../base/common/lifecycle.js';
import { isUndefinedOrNull } from '../../../base/common/types.js';
export var IStorageService = createDecorator('storageService');
export var WillSaveStateReason;

(function (WillSaveStateReason) {
  WillSaveStateReason[WillSaveStateReason["NONE"] = 0] = "NONE";
  WillSaveStateReason[WillSaveStateReason["SHUTDOWN"] = 1] = "SHUTDOWN";
})(WillSaveStateReason || (WillSaveStateReason = {}));

export var InMemoryStorageService = /*#__PURE__*/function (_Disposable) {
  _inherits(InMemoryStorageService, _Disposable);

  var _super = _createSuper(InMemoryStorageService);

  function InMemoryStorageService() {
    var _this;

    _classCallCheck(this, InMemoryStorageService);

    _this = _super.apply(this, arguments);
    _this._onDidChangeStorage = _this._register(new Emitter());
    _this._onWillSaveState = _this._register(new Emitter());
    _this.onWillSaveState = _this._onWillSaveState.event;
    _this.globalCache = new Map();
    _this.workspaceCache = new Map();
    return _this;
  }

  _createClass(InMemoryStorageService, [{
    key: "getCache",
    value: function getCache(scope) {
      return scope === 0
      /* GLOBAL */
      ? this.globalCache : this.workspaceCache;
    }
  }, {
    key: "get",
    value: function get(key, scope, fallbackValue) {
      var value = this.getCache(scope).get(key);

      if (isUndefinedOrNull(value)) {
        return fallbackValue;
      }

      return value;
    }
  }, {
    key: "getBoolean",
    value: function getBoolean(key, scope, fallbackValue) {
      var value = this.getCache(scope).get(key);

      if (isUndefinedOrNull(value)) {
        return fallbackValue;
      }

      return value === 'true';
    }
  }, {
    key: "getNumber",
    value: function getNumber(key, scope, fallbackValue) {
      var value = this.getCache(scope).get(key);

      if (isUndefinedOrNull(value)) {
        return fallbackValue;
      }

      return parseInt(value, 10);
    }
  }, {
    key: "store",
    value: function store(key, value, scope) {
      // We remove the key for undefined/null values
      if (isUndefinedOrNull(value)) {
        return this.remove(key, scope);
      } // Otherwise, convert to String and store


      var valueStr = String(value); // Return early if value already set

      var currentValue = this.getCache(scope).get(key);

      if (currentValue === valueStr) {
        return Promise.resolve();
      } // Update in cache


      this.getCache(scope).set(key, valueStr); // Events

      this._onDidChangeStorage.fire({
        scope: scope,
        key: key
      });

      return Promise.resolve();
    }
  }, {
    key: "remove",
    value: function remove(key, scope) {
      var wasDeleted = this.getCache(scope).delete(key);

      if (!wasDeleted) {
        return Promise.resolve(); // Return early if value already deleted
      } // Events


      this._onDidChangeStorage.fire({
        scope: scope,
        key: key
      });

      return Promise.resolve();
    }
  }]);

  return InMemoryStorageService;
}(Disposable);